// Material
import { Box, IconButton, Stack } from '@mui/material'
import { styled } from '@mui/material/styles'
// Common
import { BackButton } from '$common/buttons'
// Icons
// TODO: REPLACE THIS MENU ICON IN USER-LIST-ITEMS
import { MenuIcon, SettingsIcon, EditOutlinedIcon } from '$common/icons'
// Component
import { RoomProfileHeaderInfo } from './room-profile-header-info'
import { ReactNode } from 'react'

interface Props {
  onBack: () => any
  avatarElement: ReactNode
  avatarSrc: string
  primaryText: string
  secondaryText: string | number | JSX.Element
  onMenu?: () => any
  onEdit?: () => any
  onSettings?: () => any
  hasDeleted?: boolean
  avatarBackground?: string
}

const StyledStack = styled(Stack)(({ theme }) => ({
  overflow: 'hidden',
  height: 129,
  minHeight: 129,
  backgroundColor: theme.palette.neutral000,
  borderBottom: '1px solid',
  borderColor: theme.palette.neutral300,
  padding: '7px',
  boxSizing: 'border-box',
  color: theme.palette.white,
}))

export function RoomProfileHeader({
  onBack,
  avatarElement,
  avatarSrc,
  primaryText,
  secondaryText,
  onMenu,
  onEdit,
  onSettings,
  hasDeleted = false,
  avatarBackground = '',
}: Props) {
  return (
    <StyledStack>
      <Stack direction="row" justifyContent="space-between">
        <BackButton onClick={onBack} />
        <Box>
          {onSettings && (
            <IconButton
              sx={{ padding: 1, color: 'neutral900' }}
              onClick={onSettings}
            >
              <SettingsIcon />
            </IconButton>
          )}
          {onEdit && (
            <IconButton
              sx={{ padding: 1, color: 'neutral900' }}
              onClick={onEdit}
            >
              <EditOutlinedIcon />
            </IconButton>
          )}
          {onMenu && (
            <IconButton
              sx={{ padding: 1, color: 'neutral900' }}
              onClick={onMenu}
            >
              <MenuIcon fill="white" />
            </IconButton>
          )}
        </Box>
      </Stack>
      <Box>
        <RoomProfileHeaderInfo
          avatarElement={avatarElement}
          avatarSrc={avatarSrc}
          primaryText={primaryText}
          secondaryText={secondaryText}
          hasDeleted={hasDeleted}
          avatarBackground={avatarBackground}
        />
      </Box>
    </StyledStack>
  )
}
